import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetProject } from '../selectors/projects';
import { makeGetCurrentTeam } from '../selectors/teams';
import { makeGetResolvedProjectUsers, makeGetResolvedTeamUsers } from '../selectors/users';

import { inviteToProject } from '../actions/projects';

import Popout from './popout';
import FieldUser from './field-user';

import IconClose from '../icons/icon-close';

class AddUserPopout extends PureComponent {
    static defaultProps = {
        predefinedUsers: [],
        excludedUsers: [],
        size: 'xsmall'
    }

    state = {
        popoutVisible: false
    }

    handlePopoutOpenClick = () => {
        this.popoutCtrl.show();
    }

    handlePopoutCloseClick = () => {
        this.popoutCtrl.hide();
    }

    handleShow = () => {
        this.setState({
            popoutVisible: true,
        }, () => {
            setTimeout(() => {
                this.fieldCtrl && this.fieldCtrl.focus();
            }, 100);
        });

        this.props.onShow && this.props.onShow();
    }

    handleHide = () => {
        this.setState({
            popoutVisible: false
        });

        this.props.onHide && this.props.onHide();
    }

    handleUserSelect = user => {
        this.selectUser(user);

        return false;
    }

    handleFieldUserCancel = () => {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    handleUserInvite = user => {
        inviteToProject(this.props.projectId, [ user ])
            .then(({ invited }) => {
                this.props.onUserSelect && this.props.onUserSelect({
                    id: invited[0],
                    permission: user.permission
                });
            });

        this.popoutCtrl && this.popoutCtrl.hide();
    }

    selectUser(user) {
        this.popoutCtrl && this.popoutCtrl.hide();
        this.fieldCtrl && this.fieldCtrl.reset();
        this.fieldCtrl && this.fieldCtrl.hide();

        this.props.onUserSelect && this.props.onUserSelect(user);
    }

    componentWillUnmount() {
        this.popoutCtrl.hide();
    }

    render() {
        const { t } = this.props;

        const children = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick: this.handlePopoutOpenClick,
                className: child.props.className + (this.state.popoutVisible ? ' selected disable-tooltip' : '')
            });
        });

        return (
            <React.Fragment>
                { children }

                <Popout
                    className={'popout-users dark-arrow ' + this.props.size}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    yAlign={this.props.yAlign}
                    defaultYPosition={this.props.defaultYPosition}
                    closeOnEveryClick={this.props.closeOnEveryClick}
                    onShow={this.handleShow}
                    onHide={this.handleHide}
                    provideController={ctrl => this.popoutCtrl = ctrl}
                >
                    <div className="popout-head">
                        {this.props.title}

                        <button className="btn btn-icon btn-small popout-close" onClick={this.handlePopoutCloseClick}>
                            <IconClose />
                        </button>
                    </div>

                    <div className="popout-main">
                        <FieldUser
                            placeholder={t('Search by name')}
                            suggestions={this.props.suggestions}
                            popoutFoot={{enabled: false}}
                            popoutClassName="xsmall"
                            emailMatchText={this.props.emailMatchText}
                            noMatchText={this.props.noMatchText}
                            roles={this.props.roles}
                            permissions={this.props.permissions}
                            showEmpty={true}
                            onSelect={this.handleUserSelect}
                            onCancel={this.handleFieldUserCancel}
                            onInvite={this.handleUserInvite}
                            provideController={ctrl => this.fieldCtrl = ctrl}
                        />
                    </div>
                </Popout>
            </React.Fragment>
        );
    }
}

const makeMapStateToProps = () => {
    const getProject = makeGetProject();
    const getCurrentTeam = makeGetCurrentTeam();
    const getResolvedProjectUsers = makeGetResolvedProjectUsers();
    const getResolvedTeamUsers = makeGetResolvedTeamUsers();

    return ({ projects, teams, users }, ownProps) => {
        const project = getProject(projects.items, ownProps.projectId);
        const team = getCurrentTeam(teams);

        return {
            suggestions: project ? getResolvedProjectUsers(project, users, ownProps.excludedUsers) : (team ? getResolvedTeamUsers(team, users) : [])
        };
    }
}

export default connect(makeMapStateToProps)(withTranslation('common')(AddUserPopout));
